import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g clip-path="url(#a)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" > <path d="M6 5.699a1.303 1.303 0 1 0 0-2.607 1.303 1.303 0 0 0 0 2.607ZM3.933 8.907h4.133c.458 0 .81-.394.597-.798C8.348 7.513 7.631 6.802 6 6.802c-1.632 0-2.349.71-2.663 1.307-.214.404.139.798.596.798Z" /> </g> <circle cx="6" cy="6" r="5.5" stroke="currentColor" /> <defs> <clipPath id="a"> <path fill="currentColor" transform="translate(.5 .5)" d="M0 0h11v11H0z" /> </clipPath> </defs>' }
  })
);